module.exports = __webpack_public_path__ + "static/media/logo.f3b99800.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/logo.svg
// module id = 406
// module chunks = 0